//App types

export const INITIALIZE_APP = 'INITIALIZE_APP';

//Auth types

export const SET_AUTH_USER_DATA = 'SET_AUTH_USER_DATA';
export const SET_USER_INFO = 'SET_USER_INFO';
export const LOGIN = 'LOGIN';
export const LOG_OUT = 'LOG_OUT';
export const SET_CAPTCHA = 'SET_CAPTCHA';


//Profile types

export const ADD_POST = 'ADD_POST';
export const CHANGE_POST_TEXT = 'CHANGE_POST_TEXT';
export const SET_PROFILE = 'SET_PROFILE';
export const SET_FETCH = 'SET_FETCH';
export const SET_EDIT_MODE = 'SET_EDIT_MODE';

//Users types

export const SET_USERS = 'SET_USERS';
export const SET_FRIENDS = 'SET_FRIENDS';
export const FOLLOW = 'FOLLOW';
export const UNFOLLOW = 'UNFOLLOW';
export const SET_LOAD = 'SET_LOAD';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SEARCH_USERS = 'SEARCH_USERS';

// Chat types

export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SET_CHATROOM_TITLE = 'SET_CHATROOM_TITLE';
export const SET_CHATROOM_MEMBERS = 'SET_CHATROOM_MEMBERS';
export const SET_CHATROOM_MESSAGES = 'SET_CHATROOM_MESSAGES';
export const SET_ME = 'SET_ME';

